const base = require('./base')
const videoBriefingAPI = {
  videoInfoList:base.base.PHPPath+'joywork/video_briefing/videoinfolist',                   //视频列表
  allvideoInfoList:base.base.PHPPath+'joywork/video_briefing/allvideoInfoList',                   //视频列表
  labelList:base.base.PHPPath+'joywork/video_briefing/labelList',                           //标签列表
  submitFeedBack:base.base.PHPPath+'joywork/video_briefing/submitFeedBack',                 //提交反馈
}
module.exports={
  videoBriefingAPI:videoBriefingAPI
}


// WEBPACK FOOTER //
// ./src/api/videoBriefing.js